/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  limitMode,
  objectId,
  systemGameId,
} = require('../.private').components;

module.exports = {
  getCustomerDealerPropertyBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  updateCustomerDealerPropertyById: {
    properties: {
      body: {
        properties: {
          limitMode,
        },
        required: ['limitMode'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
